module.exports = __webpack_public_path__ + "img/8447dfa3b35ada7bba04dd10ef70bfe.65dbeef2.png";